import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/router";
import { AuthProvider } from "./auth/AuthProvider";
import { UiLanguageProvider } from "./i18n/UiLanguageProvider";
import "./styles/globals.css";
import "./rf-admin/rf-admin.css";

// アプリケーションのエントリポイント
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <UiLanguageProvider>
        <RouterProvider router={router} />
      </UiLanguageProvider>
    </AuthProvider>
  </React.StrictMode>
);
